import { BellOutlined, ControlOutlined, MailOutlined } from '@ant-design/icons'
import FormCard from '@components/FormCard'
import { SendTestButton } from '@components/notifications/push-wizard/components/SendTestButton'
import { SendTestModal } from '@components/notifications/push-wizard/components/SendTestModal'
import { NotificationSettingItem } from '@components/NotificationSettingList'
import { CommunicationKey } from '@models/Communication'
import { NotificationContentKey } from '@models/NotificationContent'
import { SettingKey } from '@models/Setting'
import { sendNotificationPreview } from '@services/AdminService'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { Col, Space } from 'antd'

export const membershipNotificationItems: NotificationSettingItem[] = [
  {
    slug: 'event-no-show',
    title: 'Event no-show',
    recipient: 'user',
    icon: 'bell',
    description: `Customize when and what the user will receive after set to no-show`,
    enabledSettingKey: SettingKey.MEMBERSHIP_NOSHOW_NOTIFICATION_ENABLED,
    onTestClick: (
      <SendTestModal
        communicationKey={CommunicationKey.NOTIFICATION_MEMBERSHIP_NOSHOW}
      />
    ),
    content: (
      <>
        <Col span={14}>
          <FormCard
            title="Notification content"
            icon={<MailOutlined />}
            entity={Entity.notificationContent}
            action={SBRMAction.Update}
            metadata={[
              {
                key: MetadataKey.NotificationContent,
                value: NotificationContentKey.MEMBERSHIP_NOSHOW,
              },
            ]}
          />
        </Col>
        <Col span={10}>
          <FormCard
            title="Notification delay"
            description={`Enter the notification send delay after the event end.`}
            icon={<ControlOutlined />}
            entity={Entity.setting}
            action={SBRMAction.Update}
            metadata={[
              {
                key: MetadataKey.Setting,
                value: SettingKey.MEMBERSHIP_NOSHOW_NOTIFICATION_TIME,
              },
            ]}
          />
        </Col>
      </>
    ),
  },
  {
    slug: 'event-confirmation',
    title: 'Event confirmation',
    recipient: 'user',
    icon: 'bell',
    description: `Sent to the customer to confirm they attendance to an upcoming event they participate to`,
    onTestClick: (
      <SendTestModal
        communicationKey={CommunicationKey.NOTIFICATION_MEMBERSHIP_CONFIRMATION}
      />
    ),
    content: (
      <>
        <Col span={12}>
          <FormCard
            title="Confirmation status"
            description={`Select the status that will be automatically assigned when confirming an event.`}
            icon={<ControlOutlined />}
            entity={Entity.setting}
            action={SBRMAction.Update}
            metadata={[
              {
                key: MetadataKey.Setting,
                value: SettingKey.MEMBERSHIP_CONFIRMATION_CONFIRMATION_STATUS,
              },
            ]}
          />
        </Col>
        <Col span={12}>
          <FormCard
            title="Notification delay"
            description={`Enter the notification send delay before the event start.`}
            icon={<ControlOutlined />}
            entity={Entity.setting}
            action={SBRMAction.Update}
            metadata={[
              {
                key: MetadataKey.Setting,
                value: SettingKey.MEMBERSHIP_CONFIRMATION_TIME_IN_ADVANCE,
              },
            ]}
          />
        </Col>
        <Col span={24}>
          <FormCard
            title="Notification content"
            icon={<BellOutlined />}
            entity={Entity.notificationContent}
            action={SBRMAction.Update}
            metadata={[
              {
                key: MetadataKey.NotificationContent,
                value: NotificationContentKey.MEMBERSHIP_CONFIRMATION,
              },
            ]}
          />
        </Col>
      </>
    ),
  },
  {
    slug: 'birthday',
    title: 'Birthday notification',
    recipient: 'user',
    icon: 'bell',
    description: `Wish an happy birthday to your members`,
    onTestClick: (
      <SendTestModal
        communicationKey={CommunicationKey.NOTIFICATION_MEMBERSHIP_BIRTHDAY}
      />
    ),
    content: (
      <>
        <Col span={12}>
          <Space orientation="vertical" size={32} style={{ width: '100%' }}>
            <FormCard
              title="Notification delay"
              description="Select a date within 7 days before or 2 days after the birthday."
              icon={<ControlOutlined />}
              entity={Entity.setting}
              action={SBRMAction.Update}
              metadata={[
                {
                  key: MetadataKey.Setting,
                  value: SettingKey.MEMBERSHIP_BIRTHDAY_NOTIFICATION_TIME,
                },
              ]}
            />

            <FormCard
              title="Birthday modal content"
              description={`Content of the birthday modal displayed in the app.`}
              icon={<ControlOutlined />}
              entity={Entity.notificationContent}
              action={SBRMAction.Update}
              metadata={[
                {
                  key: MetadataKey.NotificationContent,
                  value: NotificationContentKey.MEMBERSHIP_BIRTHDAY_MODAL,
                },
              ]}
            />
          </Space>
        </Col>

        <Col span={12}>
          <FormCard
            title="Notification content"
            icon={<BellOutlined />}
            entity={Entity.notificationContent}
            action={SBRMAction.Update}
            metadata={[
              {
                key: MetadataKey.NotificationContent,
                value: NotificationContentKey.MEMBERSHIP_BIRTHDAY_NOTIFICATION,
              },
            ]}
          />
        </Col>
      </>
    ),
  },
  {
    slug: 'weeklyRenewal',
    title: 'Weekly upcoming renewals',
    recipient: 'admin',
    icon: 'mail',
    description: `Weekly email notifying Membership Admins and Program Managers of members renewing soon, with key details and renewal dates.`,
    onTestClick: (
      <SendTestButton
        onClick={async () =>
          await sendNotificationPreview({ type: 'renewal-reminder' })
        }
      />
    ),
  },
  {
    slug: 'birthday-admin-reminder',
    title: 'Birthday reminder',
    recipient: 'admin',
    icon: 'mail',
    description: `Weekly email notifying Membership Admins and Program Managers of members having their birthday in the coming week`,
    onTestClick: (
      <SendTestButton
        onClick={async () =>
          await sendNotificationPreview({
            type: 'birthday-reminder',
            period: 'weekly',
          })
        }
      />
    ),
  },
]
